// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:800,300);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------------------------------------------------
 # Body
--------------------------------------------------------------*/

/*--------------------------------------------------------------
 # SVG
--------------------------------------------------------------*/
.svg-loaderT{
    width: 150px;
    
}
.svg-loader {
    position: relative;
    max-width: 100%;
}
.svg-loader_growT {
    stroke-miterlimit: 10;
    stroke-dasharray: 500;
    stroke-dashoffset: -500;
    stroke-linejoin: round;
    stroke-linecap: round;
}
circle {
    stroke-width: 6;
    transition: all 1s ease-in-out;
    position: relative;
    stroke: rgb(55, 255, 0);
}

circle.wq {
    transition: all .3s ease;
}
circle.gray {
    stroke: black;
    
}

/*--------------------------------------------------------------
 # Timer Options ("- 25 +")
--------------------------------------------------------------*/

.timerControls{
    color: #fff;
    font-size: 6em;
    font-family: 'Open Sans';
    margin: 0;
    display: flex;
    justify-content: center;
    cursor: pointer;
    text-align: center;
    /*No text select*/

}
text{
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Firefox */ /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
.containerTimer{
    height: 500px;
}
@media (max-width: 976px){
    .containerTimer{
        height: 350px;
    }
}
@media (max-width: 1000px){
    .svg-loaderT{
        width: 100px;
    }
    .containerTimer{
        height: 50px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Timer/index.css"],"names":[],"mappings":"AAEA;;+DAE+D;;AAE/D;;+DAE+D;AAC/D;IACI,YAAY;;AAEhB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,eAAe;IAEf,8BAA8B;IAC9B,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IAEI,wBAAwB;AAC5B;AACA;IACI,aAAa;;AAEjB;;AAEA;;+DAE+D;;AAE/D;IACI,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;;AAErB;AACA;IACI,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,YAAY,EACb,2BAA2B;IAClD,iBAAiB,EAAE;iEAC0C;AACjE;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":["@import url(https://fonts.googleapis.com/css?family=Open+Sans:800,300);\n\n/*--------------------------------------------------------------\n # Body\n--------------------------------------------------------------*/\n\n/*--------------------------------------------------------------\n # SVG\n--------------------------------------------------------------*/\n.svg-loaderT{\n    width: 150px;\n    \n}\n.svg-loader {\n    position: relative;\n    max-width: 100%;\n}\n.svg-loader_growT {\n    stroke-miterlimit: 10;\n    stroke-dasharray: 500;\n    stroke-dashoffset: -500;\n    stroke-linejoin: round;\n    stroke-linecap: round;\n}\ncircle {\n    stroke-width: 6;\n    -webkit-transition: all 1s ease-in-out;\n    transition: all 1s ease-in-out;\n    position: relative;\n    stroke: rgb(55, 255, 0);\n}\n\ncircle.wq {\n    -webkit-transition: all .3s ease;\n    transition: all .3s ease;\n}\ncircle.gray {\n    stroke: black;\n    \n}\n\n/*--------------------------------------------------------------\n # Timer Options (\"- 25 +\")\n--------------------------------------------------------------*/\n\n.timerControls{\n    color: #fff;\n    font-size: 6em;\n    font-family: 'Open Sans';\n    margin: 0;\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n    text-align: center;\n    /*No text select*/\n\n}\ntext{\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome and Opera */\n}\n.containerTimer{\n    height: 500px;\n}\n@media (max-width: 976px){\n    .containerTimer{\n        height: 350px;\n    }\n}\n@media (max-width: 1000px){\n    .svg-loaderT{\n        width: 100px;\n    }\n    .containerTimer{\n        height: 50px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
